export function decodeJwt(token) {
  const tokenArray = token.split('.')[1];
  return JSON.parse(window.atob(tokenArray));
}
